export default __webpack_public_path__ + "css/SalesOrder.bundle.css";